import {axiosInstance} from "@/plugins/axios";
import {
  MaterialDeclaration,
  MaterialDeclarationFilter,
  MaterialDeclarationStatusFilter, RawMaterialDeclaration
} from "@/modules/material_declaration/types";

export async function getMaterialDeclarations(payload: MaterialDeclarationFilter) {
  let url = 'material_declarations?';

  if (payload && payload.id_material_transaction) {
    url += `id_material_transaction=${payload.id_material_transaction}`
  }

  if (payload && payload.limit) {
    url += `&limit=${payload.limit}&offset=${payload.offset}`;
  }

  if(payload && payload.id_agreement) {
    url += `&id_agreement=${payload.id_agreement}`;
  }

  if(payload && payload.search) {
    url += `&search=${payload.search}`;
  }

  if (payload && payload.search_by_supplier) {
    url += `&search_by_supplier=${payload.search_by_supplier}`;
  }

  if (payload && payload.id_supplier) {
    url += `&id_supplier=${payload.id_supplier}`;
  }

  if (payload && payload.start_application_date) {
    url += `&start_application_date=${payload.start_application_date}`;
  }

  if (payload && payload.end_application_date) {
    url += `&end_application_date=${payload.end_application_date}`;
  }

  if (payload && payload.id_agreement_group) {
    url += `&id_agreement_group=${payload.id_agreement_group}`;
  }

  const response = await axiosInstance.get(url);
  return response.data;
}

export async function getMaterialDeclarationStatus(payload: MaterialDeclarationStatusFilter) {
  let url = 'material_declarations/status?';

  if (payload && payload.id_supplier) {
    url += `id_supplier=${payload.id_supplier}`
  }

  if (payload && payload.start_application_date && payload.end_application_date) {
    url += `&end_application_date=${payload.end_application_date}&start_application_date=${payload.start_application_date}`;
  }

  const response = await axiosInstance.get(url);
  return response.data;
}
export async function saveMaterialDeclaration(materialDeclaration: MaterialDeclaration) {
  const response = await axiosInstance.post(`material_declarations`, materialDeclaration);

  return response.data;
}

export async function saveMaterialDeclarations(materialDeclarations: MaterialDeclaration[]) {
  const response = await axiosInstance.post(`material_declarations/create_or_update_many`, {
    material_declarations: materialDeclarations
  });
  return response.data;
}

export async function saveRawMaterialDeclarations(materialDeclarations: RawMaterialDeclaration[]) {
  const response = await axiosInstance.post(`material_declarations/raw/create_or_update_many`, {
    material_declarations: materialDeclarations
  });
  return response.data;
}
